import {CommonModule} from '@angular/common';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {NgModule} from '@angular/core';
import {FlexLayoutModule} from '@angular/flex-layout';
import {ReactiveFormsModule} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {EffectsModule} from '@ngrx/effects';
import {StoreModule} from '@ngrx/store';
import {SharedModule} from '../shared/shared.module';
import {LoginFormComponent} from './components/login-form/login-form.component';
import {LoginPageComponent} from './containers/login-page/login-page.component';
import {AuthEffects} from './effects/auth.effects';
import {authReducers, passwordResetReducers, registrationReducers} from './reducers';
import {AnonymousAuthGuardService} from './services/anonymous-auth-guard.service';
import {AuthInterceptorService} from './services/auth-interceptor.service';
import {AuthService} from './services/auth.service';
import {AuthenticatedAuthGuardService} from './services/authenticated-auth-guard.service';
import {TokenStoreService} from './services/token-store.service';
import {TokenService} from './services/token.service';
import {UserRoutingModule} from './user-routing.module';
import {RequestPasswordResetPageComponent} from './containers/request-password-reset-page/request-password-reset-page.component';
import {RequestPasswordResetFormComponent} from './components/request-password-reset-form/request-password-reset-form.component';
import {PasswordResetService} from './services/password-reset.service';
import {PasswordResetEffects} from './effects/password-reset.effects';
import {PasswordResetFormComponent} from './components/password-reset-form/password-reset-form.component';
import {PasswordResetPageComponent} from './containers/password-reset-page/password-reset-page.component';
import {RegistrationPageComponent} from './containers/registration-page/registration-page.component';
import {RegistrationFormComponent} from './components/registration-form/registration-form.component';
import {RegistrationEffects} from './effects/registration.effects';
import {RegistrationService} from './services/registration.service';
import {ContactBoxComponent} from './components/contact-box/contact-box.component';
import {NgHcaptchaModule} from 'ng-hcaptcha';
import {environment} from '../../environments/environment';
import {GalleryModule} from 'ng-gallery';


export const COMPONENTS = [
    LoginFormComponent,
    LoginPageComponent,
    RequestPasswordResetFormComponent,
    RequestPasswordResetPageComponent,
    PasswordResetFormComponent,
    PasswordResetPageComponent,
    RegistrationFormComponent,
    RegistrationPageComponent,
    ContactBoxComponent
];

export const httpInterceptorProviders = [
    {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptorService, multi: true},
];

@NgModule({
    declarations: [COMPONENTS],
    imports: [
        CommonModule,
        SharedModule,
        ReactiveFormsModule,
        FlexLayoutModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatCardModule,
        MatProgressSpinnerModule,
        UserRoutingModule,
        GalleryModule,
        StoreModule.forFeature('auth', authReducers),
        StoreModule.forFeature('passwordReset', passwordResetReducers),
        StoreModule.forFeature('registration', registrationReducers),
        EffectsModule.forFeature([AuthEffects, PasswordResetEffects, RegistrationEffects]),
        NgHcaptchaModule.forRoot({siteKey: environment.h_captcha_sitekey})
    ],
    exports: [COMPONENTS],
    providers: [
        AuthService,
        TokenService,
        AnonymousAuthGuardService,
        AuthenticatedAuthGuardService,
        TokenStoreService,
        PasswordResetService,
        RegistrationService,
        httpInterceptorProviders
    ],
})
export class UserModule {
}
